import { useContext, useMemo } from 'react';
import GoalsContext from '../contexts/GoalsContext';
import ScorecardsContext from '../contexts/ScorecardsContext';
import WorkSpacesContext from '../contexts/WorkSpacesContext';
import { V3AppsContext } from '../contextProviders/SplashScreenProviders/UserAndAccountProviders/V3AppsProvider';
import { UIVersionContext } from '../contextProviders/SplashScreenProviders/UserAndAccountProviders/UIVersionProvider';

const useTaskItem = (task: Tasks.Task | undefined) => {
  const { isV3 } = useContext(UIVersionContext);
  const { goals } = useContext(GoalsContext);
  const { scorecards } = useContext(ScorecardsContext);
  const { allWorkSpaces: allV1V2Workspaces } = useContext(WorkSpacesContext);
  const { allWorkspaces: allV3Workspaces } = useContext(V3AppsContext);

  const allWorkSpaces = useMemo((): (
    | V3.Workspace
    | WorkSpace
    | TargetsApp.App
  )[] => {
    if (isV3) {
      return allV3Workspaces;
    }

    return allV1V2Workspaces;
  }, [allV1V2Workspaces, allV3Workspaces, isV3]);

  if (task === undefined) {
    return undefined;
  }

  if (task.taskableType === 'Goal') {
    return goals.find((g) => g.id === task.taskableId);
  } else if (task.taskableType === 'Scorecard') {
    return scorecards.find((s) => s.id === task.taskableId);
  } else if (task.taskableType === 'WorkSpace') {
    return allWorkSpaces.find((s) => s.id === task.taskableId);
  } else {
    const error = new Error();
    error.name = `Unknown item type: ${task.taskableType}`;
    throw error;
  }
};

export default useTaskItem;
